import * as call from "./callInfo"
import { standardLinks } from "./sessions"

export const serviceURL = "https://front.swoogo-retrofit.tkevents.io"

const style = document.createElement("style")
style.innerHTML = `
#unavailable {
    background: rgba(0 0 0/40%);
    cursor: not-allowed!important;
}
`

document.head.append(style)

const backgrounds = (imageurl) => [
    { background: `${imageurl}/62791/images/network-group-1.jpg`, name: "one" },
    { background: `${imageurl}/62791/images/network-group-2.jpg`, name: "two" },
    { background: `${imageurl}/62791/images/network-group-3.jpg`, name: "three" }
]

const gridLayoutBuilder = (links = []) => {
    let response = []
    const [ initialTop, stepTop, after ] = [ 21, 13.6, [ 0, 0, 0.1, 0.2 ] ]
    const [ initialLeft, stepLeft, incompleteLeft ] = [ 15.8, 12.6, 21.1 ]

    const calcPosition = (initial, position, step) => `${initial + position * step}%`

    const size = {
        width: "12.2%",
        height: "13%",
        target: "_blank"
    }

    const card = (row, position, incompleteRow = false) => ({
        left: calcPosition(incompleteRow ? incompleteLeft : initialLeft, position, stepLeft), 
        top: calcPosition(initialTop, row, stepTop + (after[row] ? after[row] : 0))
    })

    const info = (label, href) => ({ label, href, isExternal: true })
    const invalid = () => ({
        label: "unavailable",
        href: ""
    })
    // ... create grid layout for the network grid image
    // Complexity O(n)^2
    links.forEach((row, rowNb) => {
        row.forEach(({name, url, available = true}, cardPosition) => {
            let linkInfo = available ? info(name, url) : invalid()
            response.push({...size, ...card(rowNb, cardPosition, row.length < 5), ...linkInfo})
        })
    })

    return response
}

export const networkRoutes = backgrounds(serviceURL).map(({ background, name }) => ({
    background,
    name: `group-networking-cafe-${name}`,
    links: [
        ...gridLayoutBuilder(call[name] || []), 
        ...standardLinks,
        {
            width: "29.9%",
            height: "11.7%",
            left: "32%",
            top: "8.5%",
            label: call.availableTimes[name] ? "Find My Group" : "unavailable",
            href: call.availableTimes[name] ? "https://loblaw.tkeventsregistration.com/iwd2022/mytable": "",
            isExternal: true,
        }
    ]
}))